import { useEffect, useState } from "react";
import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Grid,
    IconButton,
    Paper,
    TextField,
    Tooltip,
    Typography
} from "@mui/material";
import { connect } from "react-redux";
//--------------------------|| 3RD PARTY LIBRARIES ||------------------------------------------//
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import {
    IconChecks,
    IconInfoCircle,
    IconPlus,
    IconTrash
} from "@tabler/icons-react";
//--------------------------|| FILES IMPORT ||------------------------------------------//
import {
    closeDeleteConfrimationDialog,
    closeFormulaCreateDialog,
    closeFormulaEditDialog,
    deleteFormField,
    formFieldsListErrorClear,
    formFieldsUpdateErrorClear,
    getFormFieldsList,
    openDeleteConfrimationDialog,
    openFormulaCreateDialog,
    selectedFormulaFieldForCreate,
    selectedFormulaFieldForEdit,
    setSelectedFormFieldIndex,
    updateFormFields
} from "store/app/form-management/form-congifuration/actions";
import MainCard from "ui-component/cards/MainCard";
import SubCard from "ui-component/cards/SubCard";
import FormFieldDelete from "./formFieldDelete";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { removeEmptyKeysArray } from "helper/encodeData";
import ReportCreate from "../../report-management/reports/create";
import ReportEdit from "../../report-management/reports/edit";
import { getFormulaDetails } from "store/app/report-management/reports/actions";

const options = [
    { label: 'Present/Absent', value: 'Yes/No' },
    { label: 'Number', value: 'int' },
    { label: 'Formula', value: 'formula' },
]

const styles = {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
    },
    "& input[type=number]": {
        MozAppearance: "textfield",
    },
}

const FormCongiuration = (props) => {

    const { formFieldsList, fieldDeleteConfirmationDialogOpen, isFormFieldsListPending, isFormFieldsUpdatePending, formFieldsUpdateErrorMessage,
        formFieldsListErrorMessage, userProfile, formulaCreateDialogOpen, formulaCreateData, formulaEditDialogOpen, formulaEditData, selectedFormFieldIndex } = props;
    const { userRoleName } = userProfile || {};

    const [rows, setRows] = useState([]);
    const [errors, setErrors] = useState([]);
    const [selectedFieldIndex, setSelectedFieldIndex] = useState();
    const [tableHeight, setTableHeight] = useState();

    useEffect(() => {
        props.getFormFieldsList();
        props.formFieldsUpdateErrorClear();
        props.selectedFormulaFieldForCreate();
        const closeDialog = setTimeout(() => {
            if (formulaCreateDialogOpen) {
                props.closeFormulaCreateDialog();
            }
        }, 100);
        return () => clearTimeout(closeDialog);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setTableHeight(window.innerHeight);
                });
            });
        };

        window.addEventListener("resize", handleResize);
        if (rows) handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, [rows]);

    useEffect(() => {
        setRows(formFieldsList);
    }, [formFieldsList]);

    //-------------------------------|| LIST AND DRAG&DROP ||------------------------------------------------------//
    const handleDragEnd = (result) => {
        document?.activeElement?.blur();
        if (!result.destination) return;
        const updatedRows = Array.from(rows);
        const sourceIndex = rows?.findIndex((row) => row.OrderIdx === result.source.index);
        const [movedRow] = updatedRows.splice(sourceIndex, 1);
        const destinationIndex = rows?.findIndex((row) => row.OrderIdx === result.destination.index);
        updatedRows.splice(destinationIndex, 0, movedRow);
        const reOrderRows = updatedRows.map((row, index) => {
            return {
                ...row,
                OrderIdx: index + 1,
            }
        })
        setRows(reOrderRows);
        //-----------|| ERROR ||------------//
        let currentErrors = [{}];
        reOrderRows?.map((field, index) => {
            if (!field.FieldName || !field.FieldName?.trim()) {
                currentErrors[index] = { ...currentErrors[index], FieldName: "Field name is required" };
            }
            if (!field.DataType || !field.DataType?.trim()) {
                currentErrors[index] = { ...currentErrors[index], DataType: "Data type is required" };
            }
            else {
                if (field.DataType === "formula" && !field.FieldName || !field.FieldName?.trim()) {
                    currentErrors[index] = { ...currentErrors[index], DataType: "For formula data type, field name is required" };
                }
            }
            if (field?.DataType === "int") {
                if (!field.MinScoreLimit && field.MinScoreLimit !== 0) {
                    currentErrors[index] = { ...currentErrors[index], MinScoreLimit: "Min is required" };
                }
                if (!field.MaxScoreLimit && field.MaxScoreLimit !== 0) {
                    currentErrors[index] = { ...currentErrors[index], MaxScoreLimit: "Max is required" };
                }
            }
        })
        setErrors(currentErrors)
    };

    //-------------------------------|| CREATE AND EDIT ||------------------------------------------------------//
    const handleAddNewField = () => {
        // e.preventDefault();
        const length = rows?.length;
        const lastFields = length ? rows[length - 1] : [];
        const lastOrderIdx = lastFields['OrderIdx'];
        const newFieldObj = {
            FieldName: '',
            DataType: '',
            IsRequired: false,
            IsActive: false,
            OrderIdx: lastOrderIdx ? lastOrderIdx + 1 : 0,
        }
        const updatedRows = (rows?.length) > 0 ? [...rows] : [];
        updatedRows.push(newFieldObj);
        setRows(updatedRows);
    }

    const handleFieldChange = (e, index) => {
        const { name, value, checked, type } = e.target || {};
        const selectedRows = rows[index];
        let updatedRow;

        if (name === "FieldName" && selectedRows?.DataType === "formula" && !selectedRows?.Id) {
            updatedRow = {
                ...selectedRows,
                [name]: type === 'checkbox' ? checked : name === "FieldName" ? value : value ? Number(value) : null,
                formFieldFormula: {
                    ...selectedRows?.formFieldFormula,
                    reportName: value
                }
            }
        }
        else {
            updatedRow = {
                ...selectedRows,
                [name]: type === 'checkbox' ? checked : name === "FieldName" ? value : value ? Number(value) : null,
            }
        }

        const duplicateRows = [...rows];
        duplicateRows.splice(index, 1, updatedRow);
        setRows(duplicateRows);
        //-----------|| ERROR ||------------//
        const selectedRowsErrors = errors[index];
        const updateErrors = {
            ...selectedRowsErrors,
            [name]: null,
            DataType: name === "FieldName" && selectedRows?.DataType === "formula" ? null : selectedRowsErrors?.DataType
        }
        const duplicateErrors = [...errors];
        duplicateErrors.splice(index, 1, updateErrors);
        setErrors(duplicateErrors);
    }

    const handleDataTypeChange = (e, options, index) => {
        const { value } = options || {};
        const selectedRows = rows[index];
        const updatedRow = {
            ...selectedRows,
            DataType: value,
            MinScoreLimit: null,
            MaxScoreLimit: null,
            IsRequired: value === "formula" ? false : selectedRows?.IsRequired,
            IsActive: value === "formula" ? true : selectedRows?.IsActive,

        }
        const duplicateRows = [...rows];
        duplicateRows.splice(index, 1, updatedRow);
        setRows(duplicateRows);
        if (value === "formula" && selectedRows?.FieldName) {
            const dataToSend = {
                fromName: "form-configuration",
                formulaName: selectedRows?.FieldName,
                formFieldFormula: selectedRows?.formFieldFormula,
            }
            props.selectedFormulaFieldForCreate(dataToSend);
            handleFormulaDialogOpen();
            setSelectedFieldIndex(index);
        }
        //-----------|| ERROR ||------------//
        const selectedRowsErrors = errors[index];
        const duplicateErrors = [...errors];
        const formulaValidation = value === "formula" && !selectedRows?.FieldName;
        if (formulaValidation) {
            const updateErrors = {
                ...selectedRowsErrors,
                DataType: formulaValidation ? "For formula data type, field name is required" : null,
                FieldName: formulaValidation ? "Field name is required" : selectedRowsErrors.FieldName,
            }
            duplicateErrors[index] = updateErrors;
            setErrors(duplicateErrors);
        }
        else {
            const updateErrors = {
                ...selectedRowsErrors,
                DataType: null,
                MinScoreLimit: value === "Yes/No" ? null : selectedRowsErrors?.MinScoreLimit,
                MaxScoreLimit: value === "Yes/No" ? null : selectedRowsErrors?.MaxScoreLimit,
            }
            duplicateErrors.splice(index, 1, updateErrors);
            setErrors(duplicateErrors);
        }

    }

    //-------------------------------|| DELETE ||------------------------------------------------------//
    const handleDeleteField = (e, index) => {
        e.preventDefault();
        // setSelectedFieldIndex(index);
        props.setSelectedFormFieldIndex(index);
        props.openDeleteConfrimationDialog();
    }

    const handleClose = () => {
        props.closeDeleteConfrimationDialog();
    }

    //-------------------------------|| SAVE ||------------------------------------------------------//
    const handleSave = (e) => {
        e.preventDefault();
        let currentErrors = [];
        rows?.map((field, index) => {
            if (!field.FieldName || !field.FieldName?.trim()) {
                currentErrors[index] = { ...currentErrors[index], FieldName: "Field name is required" };
            }
            if (!field.DataType || !field.DataType?.trim()) {
                currentErrors[index] = { ...currentErrors[index], DataType: "Type is required" };
            }
            if (field?.DataType === "int") {
                if (!field.MinScoreLimit && field.MinScoreLimit !== 0) {
                    currentErrors[index] = { ...currentErrors[index], MinScoreLimit: "Min is required" };
                }
                if (!field.MaxScoreLimit && field.MaxScoreLimit !== 0) {
                    currentErrors[index] = { ...currentErrors[index], MaxScoreLimit: "Max is required" };
                }
            }
        })
        setErrors(currentErrors)
        if (currentErrors.length === 0) {
            props.updateFormFields(rows);
        }
    }

    //-------------------------------|| FORMULA CREATE ||------------------------------------------------------//
    const handleFormulaDialogOpen = () => {
        props.openFormulaCreateDialog();
    }

    const handleFormulaDialogClose = (e, formulaData) => {
        if (e) {
            e.preventDefault();
        }
        props.closeFormulaCreateDialog();
        if (formulaData) {
            const selectedRow = rows[selectedFieldIndex];
            const updatedRow = { ...selectedRow, formFieldFormula: formulaData };
            const duplicateRows = [...rows];
            duplicateRows.splice(selectedFieldIndex, 1, updatedRow);
            setRows(duplicateRows);
        }
    }
    //-------------------------------|| FORMULA EDIT ||------------------------------------------------------//
    const handleFormulaEditDialogOpen = (e, id, fieldName, index) => {
        e.preventDefault();
        const dataToSend = {
            fromName: "form-configuration",
            formulaName: fieldName
        }
        props.selectedFormulaFieldForEdit(dataToSend);
        props.getFormulaDetails(id, "form-configuration");
        setSelectedFieldIndex(index);
    }

    const handleFormulaEditDialogClose = () => {
        props.closeFormulaEditDialog();
    }

    return (
        <div>
            <SubCard sx={{
                p: 1.5,
                pl: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}
            >
                <Typography variant="h4">Form Configuration</Typography>
                {/*-------------------------------|| SAVE ||------------------------------------------------------*/}
                {((rows?.length > 0) && (userRoleName === "Administrator" || userRoleName === "Master admin")) &&
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={!isFormFieldsUpdatePending && <IconChecks />}
                        onClick={handleSave}
                        disabled={isFormFieldsUpdatePending || (removeEmptyKeysArray(errors)?.length > 0)}
                    >
                        {isFormFieldsUpdatePending ?
                            <Grid item sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <CircularProgress size={'20px'} color='inherit' />
                                Loading...
                            </Grid>
                            : <>Save</>
                        }
                    </Button>
                }
            </SubCard>
            <MainCard sx={{ marginTop: '15px', overflow: "auto" }}>
                {formFieldsListErrorMessage && <ErrorAlert content={`List Error : ${formFieldsListErrorMessage}`} />}
                {formFieldsUpdateErrorMessage && <ErrorAlert content={`Update Error : ${formFieldsUpdateErrorMessage}`} />}
                <Box sx={{ minWidth: "1000px", }}>
                    {/* Header */}
                    <Grid container spacing={1} sx={{ fontWeight: "bold", mb: 1 }}>
                        <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'center', gap: "5px" }}>
                            <Typography variant="h5">Field Name</Typography>
                            <Typography variant="h4" color="error">*</Typography>
                        </Grid>
                        <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center', gap: "5px" }}>
                            <Typography variant="h5">Type</Typography>
                            <Typography variant="h4" color="error">*</Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <Grid container direction="column">
                                <Grid item sx={{ display: 'flex', justifyContent: 'center', gap: "5px" }}>
                                    <Typography variant="h5">Min</Typography>
                                    <Typography variant="h4" color="error">*</Typography>
                                </Grid>
                                <Typography variant="h6" textAlign="center">(For number types)</Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={1}>
                            <Grid container direction="column">
                                <Grid item sx={{ display: 'flex', justifyContent: 'center', gap: "5px" }}>
                                    <Typography variant="h5">Max</Typography>
                                    <Typography variant="h4" color="error">*</Typography>
                                </Grid>
                                <Typography variant="h6" textAlign="center">(For number types)</Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography variant="h5">Mandatory ?</Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography variant="h5">Active ?</Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography variant="h5" textAlign="center">Show in Report ?</Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ display: 'none', justifyContent: 'center' }}>
                            <Typography variant="h5" textAlign="center" >Show in Dashboard ?</Typography>
                        </Grid>
                        {(userRoleName === "Administrator" || userRoleName === "Master admin") &&
                            <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Typography variant="h5">Action</Typography>
                            </Grid>
                        }
                    </Grid>
                    {isFormFieldsListPending ?
                        <Grid container alignItems={"center"} justifyContent={"center"} gap={1} sx={{ minHeight: '300px' }}>
                            <CircularProgress />
                            <Typography variant="h5" color={'primary'}> Loading...</Typography>
                        </Grid>
                        : <DragDropContext onDragEnd={handleDragEnd}>
                            <Droppable droppableId="grid">
                                {(provided) => (
                                    <Box ref={provided.innerRef} {...provided.droppableProps} sx={{ overflow: "auto", maxHeight: `calc(${tableHeight}px - 300px)` }}>
                                        {rows?.map((row, index) => (
                                            <Draggable key={row?.OrderIdx} draggableId={`${row?.OrderIdx}`} index={row?.OrderIdx}>
                                                {(provided) => (
                                                    <>
                                                        <Grid
                                                            container
                                                            spacing={1}
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            component={Paper}
                                                            sx={{
                                                                my: 1,
                                                                p: 1,
                                                                display: 'flex',
                                                                alignItems: "center",
                                                                backgroundColor: "#EEEEEE",
                                                            }}
                                                        >
                                                            <Grid item xs={4}>
                                                                <TextField
                                                                    autoFocus={index === 0}
                                                                    type="text"
                                                                    multiline
                                                                    fullWidth
                                                                    size="small"
                                                                    name="FieldName"
                                                                    placeholder="Enter field name"
                                                                    onChange={(e) => handleFieldChange(e, index)}
                                                                    value={row?.FieldName}
                                                                    error={errors[index]?.FieldName}
                                                                    helperText={errors[index]?.FieldName}
                                                                    disabled={userRoleName === "User"}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Grid container>
                                                                    <Grid item md={row?.CustomReportId ? 9 : 12}>
                                                                        <Autocomplete
                                                                            options={options}
                                                                            onChange={(e, option) => handleDataTypeChange(e, option, index)}
                                                                            value={options?.find((option) => option?.value === row?.DataType) || null}
                                                                            getOptionDisabled={(option) => row?.Id && option.value === "formula"}
                                                                            disabled={userRoleName === "User" || row?.CustomReportId}
                                                                            isOptionEqualToValue={(option, value) => {
                                                                                return option?.value === value?.value;
                                                                            }}
                                                                            renderInput={(params) =>
                                                                                <TextField
                                                                                    {...params}
                                                                                    size="small"
                                                                                    placeholder="Select type"
                                                                                    error={errors[index]?.DataType}
                                                                                    helperText={errors[index]?.DataType}
                                                                                />
                                                                            }
                                                                        />
                                                                    </Grid>
                                                                    {row?.CustomReportId &&
                                                                        <Grid item md={3}>
                                                                            <Tooltip title="Formula Info" placement="top">
                                                                                <IconButton color="primary" onClick={(e) => handleFormulaEditDialogOpen(e, row?.CustomReportId, row?.FieldName, index)}>
                                                                                    <IconInfoCircle />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </Grid>
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={1}>
                                                                <TextField
                                                                    sx={{
                                                                        ...styles,
                                                                        cursor: row?.DataType !== 'int' ? "not-allowed" : "auto",
                                                                    }}
                                                                    type="number"
                                                                    fullWidth
                                                                    size="small"
                                                                    name="MinScoreLimit"
                                                                    placeholder="Enter min"
                                                                    onChange={(e) => handleFieldChange(e, index)}
                                                                    onKeyDown={
                                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                                    }
                                                                    value={row?.MinScoreLimit !== null ? row?.MinScoreLimit : ""}
                                                                    error={errors[index]?.MinScoreLimit}
                                                                    helperText={errors[index]?.MinScoreLimit}
                                                                    disabled={row?.DataType !== 'int' || userRoleName === "User"}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={1}>
                                                                <TextField
                                                                    sx={styles}
                                                                    type="number"
                                                                    fullWidth
                                                                    size="small"
                                                                    name="MaxScoreLimit"
                                                                    placeholder="Enter max"
                                                                    onChange={(e) => handleFieldChange(e, index)}
                                                                    onKeyDown={
                                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                                    }
                                                                    value={row?.MaxScoreLimit !== null ? row?.MaxScoreLimit : ""}
                                                                    error={errors[index]?.MaxScoreLimit}
                                                                    helperText={errors[index]?.MaxScoreLimit}
                                                                    disabled={row?.DataType !== 'int' || userRoleName === "User"}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                                                                <Checkbox
                                                                    name="IsRequired"
                                                                    onChange={(e) => handleFieldChange(e, index)}
                                                                    checked={row?.IsRequired}
                                                                    disabled={userRoleName === "User" || (row?.DataType === "formula")}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                                                                <Checkbox
                                                                    name="IsActive"
                                                                    onChange={(e) => handleFieldChange(e, index)}
                                                                    checked={row?.IsActive}
                                                                    disabled={userRoleName === "User" || (row?.DataType === "formula")}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                                                                <Checkbox
                                                                    name="ShowInReport"
                                                                    onChange={(e) => handleFieldChange(e, index)}
                                                                    checked={row?.ShowInReport}
                                                                    disabled={userRoleName === "User"}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={1} sx={{ display: 'none', justifyContent: 'center' }}>
                                                                <Checkbox
                                                                    name="ShowInDashboard"
                                                                    onChange={(e) => handleFieldChange(e, index)}
                                                                    checked={row?.ShowInDashboard}
                                                                    disabled={userRoleName === "User" || row?.DataType === 'formula'}
                                                                />
                                                            </Grid>
                                                            {/*-------------------------------|| DELETE ||------------------------------------------------------*/}
                                                            {(userRoleName === "Administrator" || userRoleName === "Master admin") &&
                                                                <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <Tooltip title="Delete" placement="top">
                                                                        <Button
                                                                            onClick={(e) => handleDeleteField(e, index)}
                                                                        >
                                                                            <IconTrash
                                                                                color="#C62E2E"
                                                                            />
                                                                        </Button>
                                                                    </Tooltip>
                                                                </Grid>
                                                            }
                                                        </Grid>
                                                    </>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                        {/*-------------------------------|| CREATE ||------------------------------------------------------*/}
                                        {(!formFieldsListErrorMessage && (userRoleName === "Administrator" || userRoleName === "Master admin")) &&
                                            <Grid container>
                                                <Grid item>
                                                    <Button
                                                        color="primary"
                                                        size="small"
                                                        variant="contained"
                                                        startIcon={<IconPlus size={20} />}
                                                        onClick={handleAddNewField}
                                                    >
                                                        Add New Field
                                                    </Button>
                                                </Grid>
                                            </Grid>}
                                    </Box>
                                )}
                            </Droppable>
                        </DragDropContext>
                    }
                </Box>
            </MainCard>
            {/*-------------------------------|| DELETE DIALOG ||------------------------------------------------------*/}
            <FormFieldDelete
                open={fieldDeleteConfirmationDialogOpen}
                selectedFieldIndex={selectedFormFieldIndex}
                fieldsList={rows}
                updateFields={setRows}
                updateFieldErrors={setErrors}
                handleClose={handleClose}
            />
            {/*-------------------------------|| FORMULA CREATE DIALOG ||---------------------------------------------*/}
            <ReportCreate
                open={formulaCreateDialogOpen}
                onClose={handleFormulaDialogClose}
                parent={formulaCreateData}
            />
            {/*-------------------------------|| FORMULA EDIT DIALOG ||-----------------------------------------------*/}
            <ReportEdit
                open={formulaEditDialogOpen}
                onClose={handleFormulaEditDialogClose}
                parent={formulaEditData}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    //---------------------------FORM FIELDS LIST----------------------------------
    formFieldsList: state.formConfiguration.formFieldsList,
    isFormFieldsListPending: state.formConfiguration.isFormFieldsListPending,
    formFieldsListErrorMessage: state.formConfiguration.formFieldsListErrorMessage,
    //---------------------------FORM FIELDS SAVE----------------------------------
    selectedFormFieldIndex: state.formConfiguration.selectedFormFieldIndex,
    isFormFieldsUpdatePending: state.formConfiguration.isFormFieldsUpdatePending,
    formFieldsUpdateErrorMessage: state.formConfiguration.formFieldsUpdateErrorMessage,
    //---------------------------DELETE FORM FIELDS--------------------------------
    fieldDeleteConfirmationDialogOpen: state.formConfiguration.fieldDeleteConfirmationDialogOpen,
    //---------------------------FORMULA CREATE DIALOG-----------------------------
    formulaCreateDialogOpen: state.formConfiguration.formulaCreateDialogOpen,
    formulaCreateData: state.formConfiguration.formulaCreateData,
    //---------------------------FORMULA EDIT DIALOG-------------------------------
    formulaEditDialogOpen: state.formConfiguration.formulaEditDialogOpen,
    formulaEditData: state.formConfiguration.formulaEditData,
    //---------------------------PROFILE-------------------------------------------
    userProfile: state.login.userProfile,
});

const mapDispatchToProps = (dispatch) => ({
    //---------------------------FORM FIELDS LIST----------------------------------
    getFormFieldsList: () => dispatch(getFormFieldsList()),
    formFieldsListErrorClear: () => dispatch(formFieldsListErrorClear()),
    formFieldsUpdateErrorClear: () => dispatch(formFieldsUpdateErrorClear()),
    //---------------------------FORM FIELDS SAVE----------------------------------
    setSelectedFormFieldIndex: (index) => dispatch(setSelectedFormFieldIndex(index)),
    updateFormFields: (rows) => dispatch(updateFormFields(rows)),
    //---------------------------DELETE FORM FIELDS--------------------------------
    deleteFormField: (selectedFieldId) => dispatch(deleteFormField(selectedFieldId)),
    openDeleteConfrimationDialog: () => dispatch(openDeleteConfrimationDialog()),
    closeDeleteConfrimationDialog: () => dispatch(closeDeleteConfrimationDialog()),
    //---------------------------FORMULA CREATE DIALOG-----------------------------
    openFormulaCreateDialog: () => dispatch(openFormulaCreateDialog()),
    closeFormulaCreateDialog: () => dispatch(closeFormulaCreateDialog()),
    selectedFormulaFieldForCreate: (data) => dispatch(selectedFormulaFieldForCreate(data)),
    //---------------------------FORMULA EDIT DIALOG-------------------------------
    getFormulaDetails: (id, from) => dispatch(getFormulaDetails(id, from)),
    closeFormulaEditDialog: () => dispatch(closeFormulaEditDialog()),
    selectedFormulaFieldForEdit: (data) => dispatch(selectedFormulaFieldForEdit(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormCongiuration);